/*
 * @Author: qianyl
 * @Descripttion:
 * @Date: 2024-12-23 10:06:56
 * @LastEditors: codesides
 * @LastEditTime: 2026-04-09 14:40:42
 * @FilePath: \lesson-web-cms\src\router\index.ts
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import store from '@/store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../views/indexPage.vue'),
    redirect: '/home',
    children: [
      // 首页
      {
        path: 'home',
        component: () => import('../views/home/index.vue'),
      },
      {
        // 无权限
        path: '/noPermission',
        component: () => import('../views/error/noPermission.vue'),
        meta: {
          withoutSider: true,
        },
      },

      // 资源监管
      {
        path: 'resource',
        component: () => import('../views/resources/index.vue'),
        redirect: '/resource/mine',
        children: [
          {
            path: 'mine',
            component: () => import('../views/resources/mine/index.vue'),
          },
          {
            path: 'mine/edit',
            component: () => import('../views/resources/mine/edit.vue'),
          },
          {
            path: 'mine/detail',
            component: () => import('../views/resources/mine/edit.vue'),
          },
          {
            path: 'manage/expert-audit',
            component: () => import('../views/resources/mine/edit.vue'),
          },
          {
            path: 'mine/edit-base',
            component: () => import('../views/resources/mine/edit-base.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
          {
            path: 'mine/edit-section',
            component: () => import('../views/resources/mine/edit-section.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
          {
            path: 'manage',
            component: () => import('../views/resources/manage/index.vue'),
          },
          {
            path: 'detail/:id',
            component: () => import('../views/resources/detail.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
          {
            path: 'list',
            component: () => import('../views/resources/list/index.vue'),
          },
          {
            path: 'subDetail',
            component: () => import('../views/resources/subDetail.vue'),
            meta: {
              withoutSider: true,
            },
          },
        ],
      },
      // 校外机构
      {
        path: 'institution',
        component: () => import('../views/institution/index.vue'),
        redirect: '/institution/project',
        children: [
          {
            path: 'audit',
            name: 'institutionAudit',
            component: () => import('../views/institution/selectAudit.vue'),
          },
          {
            path: 'audit/edit',
            name: 'institutionAuditEdit',
            component: () => import('../views/institution/selectAuditEdit.vue'),
          },
          {
            path: 'white',
            name: 'institutionWhiteReview',
            component: () => import('../views/institution/whiteReview.vue'),
          },
          {
            path: 'roster',
            name: 'institutionRoster',
            component: () => import('../views/institution/roster.vue'),
          },
          {
            path: 'selection',
            name: 'selection',
            component: () => import('../views/selectionAudit/index.vue'),
          },
          {
            path: 'whiteList',
            name: 'institutionWhiteList',
            component: () => import('../views/institution/whiteList.vue'),
          },
          {
            path: 'whiteList/detail',
            name: 'institutionWhiteListDetail',
            component: () => import('../views/institution/whiteListDetail.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
        ],
      },
      // 费用统计
      {
        path: 'fund',
        component: () => import('../views/fund/index.vue'),
        redirect: '/fund/index',
        children: [
          {
            path: 'index',
            component: () => import('../views/fund/fund.vue'),
          },
          {
            path: 'qu',
            component: () => import('../views/fund/fund-qu.vue'),
          },
          {
            path: 'detail',
            component: () => import('../views/fund/fund-detail.vue'),
          },
        ],
      },
      {
        // 修改密码
        path: 'reset',
        component: () => import('../views/reset/index.vue'),
      },
      {
        // 开课情况
        path: 'coursesituation/real',
        component: () => import('../views/classSituation/real.vue'),
        children: [
          {
            path: 'opening',
            component: () =>
              import('../views/courseSituation/province-opening.vue'),
          },
          {
            path: 'opening/second',
            component: () =>
              import('../views/courseSituation/second-opening.vue'),
          },
          {
            path: 'opening/school',
            component: () =>
              import('../views/courseSituation/school-opening.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
        ],
      },
      {
        // 开课情况
        path: 'coursesituation',
        redirect: 'coursesituation/opening',
        component: () => import('../views/classSituation/index.vue'),
        children: [
          {
            path: 'opening',
            component: () =>
              import('../views/courseSituation/province-opening.vue'),
          },
          {
            path: 'opening/second',
            component: () =>
              import('../views/courseSituation/second-opening.vue'),
          },
          {
            path: 'opening/school',
            component: () =>
              import('../views/courseSituation/school-opening.vue'),
            meta: {
              notNeedPermission: true,
            },
          },
        ],
      },
      {
        //  系统设置
        path: 'system',
        redirect: 'system/baseinfo',
        component: () => import('../views/setting/index.vue'),
        children: [
          {
            path: 'user',
            component: () => import('../views/setting/user.vue'),
          },
          {
            path: 'role',
            component: () => import('../views/setting/role.vue'),
          },
          {
            path: 'role/edit',
            component: () => import('../views/setting/role-edit.vue'),
          },
          // 单位管理
          {
            path: 'unit',
            component: () => import('../views/setting/unit.vue'),
          },
          // 学校管理
          {
            path: 'school',
            component: () => import('../views/setting/school.vue'),
          },
          {
            path: 'school/detail/:id',
            component: () => import('../views/setting/school-detail.vue'),
          },
          // 安全管理
          {
            path: 'safe',
            component: () => import('../views/setting/safe.vue'),
          },
        ],
      },
      {
        // 考勤统计
        path: 'attendanceStatistics',
        component: () => import('../views/attendanceStatistics/index.vue'),
      },
      {
        // 错误页面统一跳转home
        path: '/:pathMatch(.*)*',
        redirect: '/noPermission',
      },
      // 课表审核列表
      {
        path: '/schedule_audit',
        component: () => import('../views/scheduleAudit/index.vue'),
      },
      {
        path: '/schedule_audit_details',
        name: 'scheduleDetails',
        component: () => import('../views/scheduleAudit/schedule_details.vue'),
      },
    ],
  },
  {
    path: '/help',
    component: () => import('@/views/helpCenter/index.vue'),
  },
  {
    path: '/pptPreview/:id',
    component: () => import('@/views/pptPreview/index.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(
    process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : '/',
  ),
  routes,
})

router.beforeEach((to, from, next) => {
  console.log(to.path, 'to.path')

  if (!store.state.loaded) return
  const modules = store.getters.getModules

  if (to.meta.notNeedPermission) {
    next()
    return
  }
  if (['/', '/home'].includes(to.path)) {
    if (modules.length) {
      const firstUrl = modules[0].url.replace('/view/area/#', '')
      if (firstUrl !== '/home') {
        if (firstUrl && !modules[0].openType) {
          next(firstUrl)
          return
        } else if (modules[0]?.children?.length) {
          next(modules[0]?.children[0].url.replace('/view/area/#', ''))
          return
        } else if (modules[0].openType) {
          if (modules.length === 1) {
            next(firstUrl)
            return
          } else {
            const secondUrl = modules[1].url.replace('/view/area/#', '')
            const secondCUrl = modules[1].children
              ? modules[1].children[0].url.replace('/view/area/#', '')
              : ''
            const finalUrl = secondUrl || secondCUrl
            if (finalUrl === to.path) {
              next()
              return
            } else {
              next(finalUrl)
              return
            }
          }
        }
      }
    } else {
      console.log(1)
      // 无权限
      next('/noPermission')
      return
    }
  }
  next()
})

export default router
